module.exports = __webpack_public_path__ + "media/images/background-mask-a2d6da17e0e6729ee927f8f83a46f17b.svg";